import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Circle, Divider } from '@alycecom/ui';

import { IAlyceCustomTheme } from '../../../../../styles/alyceTheme';

const useStyles = makeStyles<IAlyceCustomTheme>(({ spacing, palette, zIndex }) => ({
  root: {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    textAlign: 'center',
    color: palette.text.primary,
    position: 'relative',
    marginTop: spacing(1),
    marginBottom: spacing(1),
    height: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divider: {
    zIndex: zIndex.mobileStepper,
  },
  circle: {
    zIndex: zIndex.mobileStepper + 1,
    position: 'absolute',
  },
}));

const ButtonsDivider = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Divider className={classes.divider} />
      <Circle className={classes.circle}>Or</Circle>
    </Box>
  );
};

export default ButtonsDivider;
